'use client';

import {
  useMemo,
  useState,
  useRef,
  useEffect,
} from 'react';
import { Box } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';

import './AppErrorBoundary.scss';

const AppErrorBoundary = ({ children }) => {
  const { t, i18n } = useTranslation();
  const containerRef = useRef(null);

  const [table, setTable] = useState<boolean>(false);

  const fallback = useMemo(() => (
    <Box className={classNames('fallback-error', { table })} ref={containerRef}>
      <FontAwesomeIcon icon={faCircleExclamation} />
      {t('somethingWentWrong')}
    </Box>
  ), [i18n, containerRef, table]);

  useEffect(() => {
    const tableParent = (containerRef?.current as HTMLElement | null)?.closest('.MuiDataGrid-virtualScroller');
    setTable(!!tableParent);
  }, [containerRef?.current]);

  return (
    <ErrorBoundary fallback={fallback}>
      {children}
    </ErrorBoundary>
  );
};

export default AppErrorBoundary;
